var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xl": "", "pt-1": "" } },
    [
      _c("core-refresh-informer", {
        attrs: { time: _vm.refreshTime },
        on: {
          refresh: function ($event) {
            return _vm.refreshRows(true)
          },
        },
      }),
      _c("core-filter"),
      _c(
        "v-layout",
        {
          staticClass: "work-centers-monitor-toolbar",
          attrs: {
            column: "",
            "align-end": "",
            "mt-xs--75": "",
            "mt-sm--75": "",
            "mt-md--75": "",
            "mt-lg--75": "",
            "mt-xl--75": "",
          },
        },
        [
          _c(
            "v-flex",
            { attrs: { "pa-0": "", "mr-4": "" } },
            [
              _c(
                "v-radio-group",
                {
                  staticClass: "inline-switch",
                  attrs: { row: "" },
                  on: { change: _vm.handleDisplayModeChange },
                  model: {
                    value: _vm.displayMode,
                    callback: function ($$v) {
                      _vm.displayMode = $$v
                    },
                    expression: "displayMode",
                  },
                },
                [
                  _c(
                    "okil-tooltip",
                    {
                      attrs: {
                        show: "",
                        bottom: "",
                        hint: _vm.$t("Common.singleList"),
                      },
                    },
                    [
                      _c("v-radio", {
                        attrs: {
                          value: "all",
                          "off-icon": "mdi-format-list-bulleted",
                          "on-icon": "mdi-format-list-bulleted-square",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "okil-tooltip",
                    {
                      attrs: {
                        show: "",
                        bottom: "",
                        hint: _vm.$t("Common.bySites"),
                      },
                    },
                    [
                      _c("v-radio", {
                        attrs: {
                          value: "site",
                          "off-icon": "mdi-domain",
                          "on-icon": "mdi-domain",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      [
        _vm.isDesktopView
          ? [
              _c("sticky-table-header", {
                attrs: {
                  headers: _vm.localizedHeaders,
                  "headers-widths": _vm.headersWidths,
                  show: _vm.showStickyHeader,
                  updating: _vm.updating,
                },
              }),
              _vm._l(_vm.displayGroups, function (group) {
                return _c(
                  "v-card",
                  {
                    key: group.key,
                    staticClass:
                      "mobile-margin work-centers-monitor-group-card",
                  },
                  [
                    group.title
                      ? _c(
                          "div",
                          { staticClass: "work-centers-monitor-group-title" },
                          [_vm._v(" " + _vm._s(group.title) + " ")]
                        )
                      : _vm._e(),
                    _c("v-data-table", {
                      class: [
                        "elevation-1 work-centers-monitor",
                        _vm.renderGroupBySite
                          ? "work-centers-monitor-grouped"
                          : "",
                      ],
                      style: _vm.groupedDesktopTableStyles,
                      attrs: {
                        headers: _vm.localizedHeaders,
                        items: group.items,
                        search: _vm.search,
                        "item-key": "WorkСenter",
                        "rows-per-page-items": _vm.rowsPerPageItems,
                        "rows-per-page-text": _vm.$t("Common.rowsPerPage"),
                        loading: _vm.updating,
                        "disable-initial-sort": "",
                        "hide-actions": "",
                        "fixed-header": "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "headers",
                            fn: function ({ headers: tableHeaders }) {
                              return [
                                _c(
                                  "tr",
                                  { ref: "headers-row", refInFor: true },
                                  _vm._l(
                                    tableHeaders,
                                    function (header, index) {
                                      return _c(
                                        "th",
                                        {
                                          key: header.name,
                                          ref: `header-${index}`,
                                          refInFor: true,
                                          staticClass:
                                            "column text-xs-left header",
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(header.name) + " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                                _vm.updating
                                  ? _c("tr", { staticClass: "progress" }, [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "progress",
                                          attrs: {
                                            colspan: tableHeaders.length,
                                          },
                                        },
                                        [
                                          _c("v-progress-linear", {
                                            attrs: {
                                              height: "2",
                                              color: "green",
                                              indeterminate: "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "items",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "tr",
                                  { class: _vm.getRowClass(item) },
                                  [
                                    _c("work-center-cell", {
                                      attrs: { item: item },
                                      on: {
                                        "get-om": _vm.handleGetOM,
                                        "set-print-form": _vm.setPrintForm,
                                      },
                                    }),
                                    _c("order-status-cell", {
                                      attrs: { item: item, width: 300 },
                                    }),
                                    _c("overrun-cell", {
                                      attrs: { item: item },
                                    }),
                                    _c("work-center-status-cell", {
                                      attrs: { item: item },
                                    }),
                                    _c("tuning-cell", {
                                      attrs: { item: item },
                                    }),
                                    _c("printing-cell", {
                                      attrs: { item: item },
                                    }),
                                    _c("time-to-end-cell", {
                                      attrs: { item: item },
                                    }),
                                    _c("paint-time-cell", {
                                      attrs: { item: item },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "no-data",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "text-xs-center" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.isLoading
                                          ? _vm.waitMsg
                                          : _vm.noDataMsg
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                )
              }),
            ]
          : [
              _c("sticky-table-header", {
                attrs: {
                  headers: _vm.mobileHeaders,
                  "headers-widths": _vm.mobileHeadersWidths,
                  show: _vm.showStickyHeader,
                  updating: _vm.updating,
                },
              }),
              _vm._l(_vm.displayGroups, function (group) {
                return _c(
                  "v-card",
                  {
                    key: group.key,
                    staticClass:
                      "mobile-margin work-centers-monitor-group-card",
                  },
                  [
                    group.title
                      ? _c(
                          "div",
                          { staticClass: "work-centers-monitor-group-title" },
                          [_vm._v(" " + _vm._s(group.title) + " ")]
                        )
                      : _vm._e(),
                    _c("v-data-table", {
                      staticClass: "work-centers-monitor-mobile",
                      attrs: {
                        headers: _vm.mobileHeaders,
                        items: group.items,
                        search: _vm.search,
                        "item-key": "WorkСenter",
                        loading: _vm.updating,
                        "disable-initial-sort": "",
                        "hide-actions": "",
                        dense: "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "headers",
                            fn: function ({ headers: tableHeaders }) {
                              return [
                                _c(
                                  "tr",
                                  _vm._l(
                                    tableHeaders,
                                    function (header, index) {
                                      return _c(
                                        "th",
                                        {
                                          key: `mobile-header-${index}`,
                                          ref: `header-${index}`,
                                          refInFor: true,
                                          staticClass:
                                            "column text-xs-left header",
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(header.name) + " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                                _vm.updating
                                  ? _c("tr", { staticClass: "progress" }, [
                                      _c(
                                        "td",
                                        {
                                          staticClass: "progress",
                                          attrs: {
                                            colspan: tableHeaders.length,
                                          },
                                        },
                                        [
                                          _c("v-progress-linear", {
                                            attrs: {
                                              height: "2",
                                              color: "green",
                                              indeterminate: "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "items",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "tr",
                                  {
                                    key: _vm.rowKey(item),
                                    class: [
                                      "mobile-row",
                                      _vm.getRowClass(item),
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleRow(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "td",
                                      { staticClass: "mobile-cell" },
                                      [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on }) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        _vm._g({}, on),
                                                        [
                                                          _vm.mobileRowAttention(
                                                            item
                                                          )
                                                            ? _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "mobile-attention-icon",
                                                                  attrs: {
                                                                    small: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " mdi-alert-box-outline "
                                                                  ),
                                                                ]
                                                              )
                                                            : _c("span", {
                                                                staticClass:
                                                                  "mobile-attention-spacer",
                                                              }),
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.WorkСenter
                                                              )
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.WorkCenterName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _vm.showMobileOrderInfo(item)
                                          ? [
                                              _vm.hasAvTimeToChangeRoller(item)
                                                ? [
                                                    _vm._v(" | "),
                                                    _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: { top: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "span",
                                                                    _vm._g(
                                                                      {},
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.mobileAvTimeToChangeRoller(
                                                                              item
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Common.avTimeToChangeRollerSec"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm._e(),
                                              _c("div", { staticClass: "br" }),
                                              _c(
                                                "v-menu",
                                                {
                                                  attrs: { "offset-y": "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "a",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "link",
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c(
                                                                  "okil-cut-cell",
                                                                  {
                                                                    attrs: {
                                                                      text: _vm.mobileOrderText(
                                                                        item
                                                                      ),
                                                                      "text-length": 20,
                                                                      width: 200,
                                                                      "tooltip-activator": false,
                                                                      crop:
                                                                        item
                                                                          .Customer
                                                                          .length >
                                                                        10,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c(
                                                    "v-list",
                                                    [
                                                      _c(
                                                        "v-list-tile",
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                xs12: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "okil-print-form-button",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      "ОБЗ",
                                                                    "request-params":
                                                                      _vm.mobilePrintFormParams(
                                                                        item
                                                                      ),
                                                                  },
                                                                  on: {
                                                                    "set-print-form":
                                                                      _vm.setPrintForm,
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-list-tile",
                                                        [
                                                          _c(
                                                            "v-flex",
                                                            {
                                                              attrs: {
                                                                xs12: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    block: "",
                                                                    color:
                                                                      "blue-grey lighten-2",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleGetOM(
                                                                          item.DocNum,
                                                                          item.DocDate
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "mdi-image-outline"
                                                                    ),
                                                                  ]),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Common.getOM"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm.mobileOrderCalcBtnAllowed()
                                                        ? _c(
                                                            "v-list-tile",
                                                            [
                                                              _c(
                                                                "v-flex",
                                                                {
                                                                  attrs: {
                                                                    xs12: "",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "okil-print-form-button",
                                                                    {
                                                                      attrs: {
                                                                        label:
                                                                          "Расчет",
                                                                        "request-params":
                                                                          _vm.mobileCalcPrintFormParams(
                                                                            item
                                                                          ),
                                                                      },
                                                                      on: {
                                                                        "set-print-form":
                                                                          _vm.setPrintForm,
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _c(
                                      "td",
                                      {
                                        class: [
                                          "mobile-cell",
                                          "mobile-status-cell",
                                          _vm.orderStatusCellClass(item)
                                            ? "order-attention"
                                            : "",
                                        ],
                                      },
                                      [
                                        _vm.showOrderDuration(item)
                                          ? _c(
                                              "span",
                                              {
                                                class: _vm.orderStatusCellClass(
                                                  item
                                                )
                                                  ? "detail-warn"
                                                  : "",
                                              },
                                              [
                                                _c("okil-cut-cell", {
                                                  attrs: {
                                                    text: _vm.mobileOrderStatus(
                                                      item
                                                    ),
                                                    "text-length": 20,
                                                    width: 200,
                                                    "tooltip-activator": false,
                                                    crop:
                                                      _vm.mobileOrderStatus(
                                                        item
                                                      ).length > 10,
                                                  },
                                                }),
                                                _c("div", {
                                                  staticClass: "br",
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "no-wrap" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "Common.duration2"
                                                          )
                                                        ) +
                                                        ": " +
                                                        _vm._s(
                                                          _vm.mobileOrderDuration(
                                                            item
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _c("span", [_vm._v("-")]),
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "mobile-expand-icon",
                                            attrs: { small: "" },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.isRowExpanded(item)
                                                    ? "mdi-chevron-up"
                                                    : "mdi-chevron-down"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm.isRowExpanded(item)
                                  ? _c(
                                      "tr",
                                      {
                                        key: `${_vm.rowKey(item)}-details`,
                                        class: [
                                          "mobile-details-row",
                                          _vm.printingStatusClass(item),
                                        ],
                                      },
                                      [
                                        _c(
                                          "td",
                                          {
                                            class:
                                              _vm.printingStatusClass(item),
                                            attrs: { colspan: "2" },
                                          },
                                          [
                                            _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "mobile-details-table",
                                              },
                                              [
                                                _c(
                                                  "tbody",
                                                  _vm._l(
                                                    _vm.mobileDetailRows(item),
                                                    function (detail) {
                                                      return _c(
                                                        "tr",
                                                        { key: detail.key },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "detail-label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    detail.label
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              class: [
                                                                "detail-value",
                                                                detail.hasAttention
                                                                  ? "detail-attention"
                                                                  : "",
                                                              ],
                                                            },
                                                            _vm._l(
                                                              detail.valueLines,
                                                              function (
                                                                line,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: index,
                                                                    class:
                                                                      detail.warnLineIndexes &&
                                                                      detail.warnLineIndexes.includes(
                                                                        index
                                                                      )
                                                                        ? "detail-warn"
                                                                        : "",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          line
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                    detail.icon &&
                                                                    index === 0
                                                                      ? _c(
                                                                          "v-icon",
                                                                          {
                                                                            staticClass:
                                                                              "detail-icon",
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  detail
                                                                                    .icon
                                                                                    .color,
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  detail
                                                                                    .icon
                                                                                    .name
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "no-data",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "text-xs-center" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.isLoading
                                          ? _vm.waitMsg
                                          : _vm.noDataMsg
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ],
                  1
                )
              }),
            ],
        _vm.printForm
          ? _c("okil-new-pdf-viewer", {
              attrs: {
                src: _vm.printForm.doc.pdf,
                title: _vm.printForm.name,
                "show-title": "",
                "init-fullscreen": "",
              },
              on: {
                close: function ($event) {
                  _vm.printForm = undefined
                },
              },
            })
          : _vm._e(),
        _vm.omViewerOpen
          ? _c("okil-original-maket-viewer", {
              attrs: { oms: _vm.oms, fullscreen: _vm.screenWidth < 500 },
              on: { "close-om-viewer": _vm.closeOMViewer },
            })
          : _vm._e(),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }